/**
 * Test IDs for QA automation.
 */
export const testIds = {
  trailerEventFormModalDeleteEvent: "trailer-event-form-modal-delete-event",
  trailerEventFormModalCancel: "trailer-event-form-modal-cancel",
  trailerEventFormModalSave: "trailer-event-form-modal-save",
} as const;
